'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _textareaModule = require('./textarea.module.less');

var _textareaModule2 = _interopRequireDefault(_textareaModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * The textarea can be in only one visual state at a time. For example, it can
 * either be "disabled" _or_ in an error state. It can't be both. This makes
 * sure we're only applying one of these class names to the element and makes
 * it easy to see the priority of the states.
 */
var getStateClassName = function getStateClassName(_ref) {
  var error = _ref.error,
      disabled = _ref.disabled;

  if (error) {
    return _textareaModule2.default.error;
  } else if (disabled) {
    return _textareaModule2.default.disabled;
  }
  return _textareaModule2.default.default;
};

/**
 * Displays a multi-line text input box that the user can type into. This
 * component is a stateless visual wrapper on top of the html <textarea> and
 * takes many of the same props.
 */
var Textarea = function Textarea(_ref2) {
  var _classNames;

  var className = _ref2.className,
      error = _ref2.error,
      disabled = _ref2.disabled,
      fullWidth = _ref2.fullWidth,
      noResize = _ref2.noResize,
      inputRef = _ref2.inputRef,
      otherProps = _objectWithoutProperties(_ref2, ['className', 'error', 'disabled', 'fullWidth', 'noResize', 'inputRef']);

  return _react2.default.createElement('textarea', _extends({
    ref: inputRef,
    className: (0, _classnames2.default)('needsclick', // fastclick workaround
    className, _textareaModule2.default.textarea, getStateClassName({
      error: error,
      disabled: disabled
    }), (_classNames = {}, _defineProperty(_classNames, _textareaModule2.default.fullWidth, fullWidth), _defineProperty(_classNames, _textareaModule2.default.noResize, noResize), _classNames)),
    disabled: disabled
  }, otherProps));
};

Textarea.propTypes = {
  /** Show the input in an error visual state. */
  error: _propTypes2.default.bool,
  /** When true, sets width to 100% on the input. */
  fullWidth: _propTypes2.default.bool,
  /** Disable interaction and change. */
  disabled: _propTypes2.default.bool,
  /** Disable the browser resize functionality */
  noResize: _propTypes2.default.bool,
  /** Class on the <input> element. */
  className: _propTypes2.default.string,
  /** Gives access to the input dom node */
  inputRef: _propTypes2.default.func
};

exports.default = Textarea;
Textarea.__docgenInfo = {
  'description': 'Displays a multi-line text input box that the user can type into. This\ncomponent is a stateless visual wrapper on top of the html <textarea> and\ntakes many of the same props.',
  'props': {
    'error': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Show the input in an error visual state.'
    },
    'fullWidth': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'When true, sets width to 100% on the input.'
    },
    'disabled': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Disable interaction and change.'
    },
    'noResize': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Disable the browser resize functionality'
    },
    'className': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Class on the <input> element.'
    },
    'inputRef': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Gives access to the input dom node'
    }
  }
};